import { FunctionComponent } from 'react'
import HTMLView from '@components/HTMLView'
import styled, { css } from 'styled-components'
import { mobileCSS, tabletCSS } from '@measures/responsive'
import { printCSS } from '@utils/style'

interface TitleProps {
  title: string
}

const StyledTitle = styled.span`
  ${({
    theme: {
      fonts: { goodOTNarrow },
      colors: {
        grey: { grey_100 },
      },
    },
  }) => css`
    margin-top: 3px;
    font-family: ${goodOTNarrow};
    font-size: 64px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.05;
    letter-spacing: 0;
    text-align: left;
    color: ${grey_100};
    display: block;
    overflow-wrap: anywhere;
    word-break: break-word;

    ${mobileCSS(css`
      font-size: 9vw;
      line-height: 1.1;
    `)}

    ${tabletCSS(css`
      margin-top: 10px;
      font-size: 52px;
      line-height: 56px;
    `)}
    ${printCSS(css`
      font-size: 17px;
      line-height: 150%;
    `)}
  `}
`

const Title: FunctionComponent<TitleProps> = ({ title }) => {
  const allowedHtmlTags = ['sup', 'sub', 'span']

  if (title === '') {
    return null
  }

  return (
    <StyledTitle>
      <HTMLView content={title} allowedHtmlTags={allowedHtmlTags} />
    </StyledTitle>
  )
}

export default Title
